import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { appointmentBookingAddToCalendarEvent } from '../actions.js';

const useAddToCalendarDlEventDispatcher = ({ appointmentCondition , store , type , timeSlot , isVirtualAppointment  })=>{
    const pushAddToCalendarDlEvent = React.useCallback(()=>{
        if (store) {
            var ref, _globalStoreId, ref1;
            const dataLayerEvent = appointmentBookingAddToCalendarEvent({
                condition_of_appointment: appointmentCondition,
                appointment: {
                    type_of_appointment: isVirtualAppointment ? 'videocall' : 'onsite',
                    type_of_service: (ref = type === null || type === void 0 ? void 0 : type.id) !== null && ref !== void 0 ? ref : ''
                },
                storeDetails: swcHelpers.objectSpread({
                    id: (_globalStoreId = store.globalStoreId) !== null && _globalStoreId !== void 0 ? _globalStoreId : '',
                    city: store.town
                }, store),
                text_of_the_element: 'add to calendar',
                time: {
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                },
                ageGroup: (ref1 = type === null || type === void 0 ? void 0 : type.ageGroup) !== null && ref1 !== void 0 ? ref1 : 'ADULT'
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        appointmentCondition,
        store,
        type,
        timeSlot,
        isVirtualAppointment
    ]);
    return React.useMemo(()=>({
            pushAddToCalendarDlEvent
        })
    , [
        pushAddToCalendarDlEvent
    ]);
};

export { useAddToCalendarDlEventDispatcher };
//# sourceMappingURL=use-add-to-calendar-dl-event-dispatcher.js.map
